import React from "react";
import { compose, withHooks, withTranslation } from "enhancers";
import {
  Box,
  Typography,
  Field,
  Button,
  BrowseButton,
  FileUpload,
  IconButton,
} from "components";
import { get, range } from "lodash";
import { TFunction } from "i18next";
import { InputLabel } from "@material-ui/core";
import { AppColor } from "theme/app-color";
import { ReactComponent as RedTrashIcon } from "assets/icon/red_trash.svg";

interface SingleFileUploadProps {
  t: TFunction;
  label: string;
  required: boolean;
  filename: string;
  addButtonLabel: string;
  name: string;
  download: () => void;
  addDocument: any;
  removeDocument: () => void;
  hasFile: boolean;
  accept: string | string[];
}

const SingleFileUpload = ({
  t,
  label,
  required,

  filename,
  addButtonLabel,
  name,
  addDocument,
  removeDocument,
  hasFile,
  accept,
}: SingleFileUploadProps) => (
  <Box
    width="100%"
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent={label ? "space-between" : "flex-end"}
  >
    {label && (
      <InputLabel shrink htmlFor={name}>
        <Typography variant="Body/20" color={AppColor["Text/Primary Text"]}>
          {label}
          <span style={{ color: AppColor["SecondaryText/Danger"] }}>
            {required && " *"}
          </span>
        </Typography>
      </InputLabel>
    )}
    {!hasFile && (
      <BrowseButton
        onBrowse={addDocument}
        variant="outlined"
        accept={accept}
        multiple={false}
      >
        <Typography color="Text/Black">{addButtonLabel}</Typography>
      </BrowseButton>
    )}
    {hasFile && (
      <Box display="flex" alignItems="center" maxWidth="50%">
        <Field
          component={FileUpload}
          name={`${name}[0]`}
          pl={4}
          simple
          style={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        />

        <IconButton
          size="small"
          onClick={() => {
            removeDocument();
          }}
        >
          <RedTrashIcon width={18} height={18} />
        </IconButton>
      </Box>
    )}
  </Box>
);

const enhancer = compose(
  withTranslation({ prefix: "components.advance.FileUploadList" }),
  withHooks((props: any, hooks: any) => {
    const {
      form,
      name,
      insert,
      remove,
      title,
      addButtonLabel,
      mt,
      notDisplayHeader,
      simple,
      label,
      required,
      accept,
    } = props;
    const { useCallback } = hooks;
    // const amount = get(form.values, name)?.length ?? 0;

    const addDocument = useCallback(
      (file: any) => {
        insert(0, file);
      },
      [insert]
    );

    const removeDocument = useCallback(
      (index: number) => {
        remove(0);
      },
      [remove]
    );

    const hasFile = get(form.values, name)?.length > 0;

    return {
      label,
      required,

      name,
      hasFile,
      addDocument,
      removeDocument,
      title,
      addButtonLabel,
      mt,
      notDisplayHeader,
      simple,
      accept,
    };
  })
);

export default enhancer(SingleFileUpload);
